import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forget-password-page',
  templateUrl: './forget-password-page.component.html',
  styleUrls: ['./forget-password-page.component.scss']
})
export class ForgetPasswordPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
